import Footer from "../component/Footer";
import HeroSlider from "../component/HeroSlider";
import AboutWASMESection from "../component/HomeComponents/AboutWASMESection";
import EventsList from "../component/HomeComponents/EventCard";
import EventHighlights from "../component/HomeComponents/EventHighlights";
import MSMESupportSection from "../component/HomeComponents/MSMESupportSection";
import NewsletterSection from "../component/HomeComponents/NewsletterSection";
import OfficeBearers from "../component/HomeComponents/OfficeBearers";
import ServicesSection from "../component/HomeComponents/ServicesSection";
import UpcomingEventsSection from "../component/HomeComponents/UpcomingEventSection";
import Navbar from "../component/Navbar";


const Home = () => {
  return (
    <>
    <Navbar/>
      <HeroSlider/>

      <main className="bg-white">
        <AboutWASMESection/>
        <MSMESupportSection/>
        <ServicesSection/>
        <UpcomingEventsSection/>
        <EventHighlights/>
        <EventsList/>
        <OfficeBearers/>
        <NewsletterSection/>
        
      </main>
      <Footer/>
    </>
  );
};

export default Home;
